import { useEffect, useState } from "react";
import { api } from "./api";

// Frontend (UI) agent_key  →  Backend canonical key (agent_flags collection)
export const AGENT_KEY_MAP = {
  voice: "brand_voice",
  client: "avatar",
  offer: "offer",
  "magnet-post": "magnet_post",
  email: "newsletter",
  "lead-magnet": "lead_magnet",
  webinar: "webinar",
  landing: "landing",
  sales: "sales",
};

/**
 * Fetches /api/agents/visibility on mount AND on window focus, so admin
 * changes propagate to already-signed-in users when they return to the tab.
 * Returns a stable map { backend_key → status }. Tester users only see
 * 'live'/'admin_only'.
 */
export function useAgentVisibility() {
  const [statusByKey, setStatusByKey] = useState({});
  const [loaded, setLoaded] = useState(false);

  const refresh = async () => {
    try {
      const r = await api.get("/agents/visibility");
      const map = {};
      (r.data?.flags || []).forEach((f) => { map[f.agent_key] = f.status; });
      setStatusByKey(map);
    } catch {
      // fallback: assume all live so the UI doesn't lock unexpectedly
    } finally {
      setLoaded(true);
    }
  };

  useEffect(() => {
    refresh();
    // Refresh on tab focus — so admin-changed flags reach existing sessions
    // within seconds (not on next full page reload). Cheap: 1 GET / focus.
    const onFocus = () => { refresh(); };
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, []);

  const lookup = (frontendKey) => {
    const backendKey = AGENT_KEY_MAP[frontendKey] || frontendKey;
    // If backend didn't return it (tester + hidden), treat as hidden.
    return statusByKey[backendKey];
  };

  return { lookup, loaded };
}
